function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.276 5.295a1.012 1.012 0 011.428 0c.395.393.395 1.03 0 1.422L6.806 18.571a1.012 1.012 0 01-1.428 0 1.003 1.003 0 010-1.423L17.276 5.295z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.622 17.283c.395.393.395 1.03 0 1.423a1.012 1.012 0 01-1.428 0L5.296 6.852a1.003 1.003 0 010-1.422 1.012 1.012 0 011.428 0l11.898 11.853z"
})));